import {AddSchema} from "mobx-graphlink";
import {GetValues_ForSchema} from "js-vextensions";
import {TriggerSet} from "../@TriggerSet.js";
import {ChatRequestReasoningEffort} from "@openrouter/sdk/models";

export enum ThinkingType {
	disabled = "disabled",
	extended = "extended",
	adaptive = "adaptive",
}
export enum EffortLevel {
	none = "none", // Anthropic.ts: collapses to "low"
	minimal = "minimal", // Anthropic.ts: collapses to "low"
	low = "low",
	medium = "medium",
	high = "high",
	xhigh = "xhigh",
	max = "max", // OpenRouter.ts: collapses to "xhigh"
}
export function EffortLevel_ForOpenRouter(effort: EffortLevel): ChatRequestReasoningEffort {
	if (effort == EffortLevel.max) return "xhigh";
	return effort;
}
export function EffortLevel_ForAnthropic(effort: EffortLevel): "low"|"medium"|"high"|"xhigh"|"max" {
	if (effort == EffortLevel.none || effort == EffortLevel.minimal) return "low";
	return effort;
}

export class EngineConfig_StoryExplore {
	constructor(initialData: Partial<EngineConfig_StoryExplore>) { Object.assign(this, initialData); }

	enabled: boolean;

	// triggers
	prevText_triggerSet: TriggerSet;
	nextText_triggerSet: TriggerSet;
	selectText_triggerSet: TriggerSet;
	stopVoice_triggerSet: TriggerSet;
	newStory_triggerSet: TriggerSet;

	voiceSoundTag: string;
	volumeMultiplier: number;

	minNumberedListSize: number;
	dynamicListNumbers: number[];
	llmHistory_keepLastXNumberedLists: number;
	temperature: number;
	thinkingType: ThinkingType;
	thinking_budgetTokens: number;
	responseTokens: number;
	effort: EffortLevel;
	startPrompt: string;
}
AddSchema("EngineConfig_StoryExplore", {
	properties: {
		enabled: {type: "boolean"},

		prevText_triggerSet: {$ref: "TriggerSet"},
		nextText_triggerSet: {$ref: "TriggerSet"},
		selectText_triggerSet: {$ref: "TriggerSet"},
		stopVoice_triggerSet: {$ref: "TriggerSet"},
		newStory_triggerSet: {$ref: "TriggerSet"},

		voiceSoundTag: {type: "string"},
		volumeMultiplier: {type: "number"},

		minNumberedListSize: {type: "number"},
		dynamicListNumbers: {items: {type: "number"}},
		llmHistory_keepLastXNumberedLists: {type: "number"},
		temperature: {type: "number"},
		thinkingType: {type: "string"},
		thinking_budgetTokens: {type: "number"},
		responseTokens: {type: "number"},
		effort: {type: "string"},
		startPrompt: {type: "string"},
	},
});